import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-input',
  templateUrl: './button-input.component.html',
  styleUrls: ['./button-input.component.scss']
})
export class ButtonInputComponent implements OnInit {
  @Input() public disabled = false;
  @Input() public type = 'text';

  @Input() public initialValue: any;

  @Input() public value: any;
  @Output() public valueChange = new EventEmitter<any>();

  @Output() public apply = new EventEmitter<void>();
  @Output() public cancel = new EventEmitter<void>();

  constructor() {}

  public ngOnInit() {}

  public requireNumber(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return charCode <= 31 || (charCode >= 48 && charCode <= 57);
  }
}
